import {ReactNode, useEffect} from 'react';
import {ccWebviewUtils} from '@shared/cci/features/webviewUtils';
import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';
import useHistoryLock from '@di-shared/features/history/setting/useHistoryLock';

interface HistoryLockProps {
  vin: string;
  fallbackLoading: ReactNode;
  fallbackError: ReactNode;
  children: ReactNode;

  onFail?: () => void;
}

export default function HistoryLock({vin, fallbackLoading, fallbackError, children, onFail}: HistoryLockProps) {
  const {isHistoryUnlock, unlock, isError} = useHistoryLock({vin});
  const {backOrClose} = useCcWebviewUtilsHelper();

  useEffect(() => {
    (async function () {
      if (isHistoryUnlock === null || isHistoryUnlock) {
        return;
      }

      const {isCanceled, isAuth} = await ccWebviewUtils.authRequest();
      if (isCanceled || !isAuth) {
        onFail ? onFail() : backOrClose();
        return;
      }
      unlock();
    })();
  }, [isHistoryUnlock]);

  return isError ? <>{fallbackError}</> : isHistoryUnlock ? <>{children}</> : <>{fallbackLoading}</>;
}
